import { initMain } from "./vue/controllers/main";
import { header } from "./vue/controllers/header";
import lazyload from "./features/lazy-load";
import stickyScroll from "./features/sticky-scroll";
import { editorialStaffMixin } from "./vue/mixins/editorial-staff";
lazyload();
stickyScroll();

initMain(
  [editorialStaffMixin],
  {
    EditorialStaffPager: () =>
      import("./vue/components/editorial-staff-pager/EditorialStaffPager.vue"),
  },
  []
);
header();
